<template>
	<div class="instruc hello-wrapper">
		<div class="panel white-tilted-1">
			<div class="wrapper">
				<div class="left">
					<h1 class="heading">
						Instruções
					</h1>
					<div class="icons">
						<div class="icon tp">
							<span class="texto">Tempo de prova</span>
							<div>
								{{ tempoParaFazer }}h
							</div>
						</div>
						<div class="icon cp">
							<span class="texto">Conclua a prova até</span>
							<div>
								{{ simulado.DiaMaximo }}
								<span class="small">
									{{ simulado.MesMaximo}}
								</span>
							</div>
						</div>
						<div class="icon ma">
							<span class="texto">Máximo de acessos à prova</span>
							<div>
								{{ simulado.SimuladoMaximoDeAcessos }}
							</div>
						</div>
					</div>
					<ul>
						<li>Leia todas as instruções de cada parte com atenção;</li>
						<li>Questões não respondidas serão consideradas erradas;</li>
						<li>Dê preferência a conexão de Internet via cabo e não wifi;</li>
						<li>Faça o simulado em um computador ou notebook.</li>
					</ul>
					<div class="boa-sorte">
						Boa sorte!
					</div>
				</div>
				<div class="right">
					<h2>
						Teste de áudio
					</h2>
					<p>
						Uma parte do teste irá utilizar o sistema de áudio. Verifique se o seu sistema de áudio está funcionando corretamente. Você pode realizar este teste clicando no botão abaixo:
					</p>
					<div class="teste">
						<div @click="play" class="button"></div>
						<p>
							Se você identificar qualquer problema com o áudio, verifique o volume. Se o problema persistir, por favor, entre em contato com a sua unidade do CNA.
						</p>
					</div>
					<div class="checkbox">
						<checkbox v-model="testouAudio"></checkbox>
						Meu áudio está funcionando!
					</div>
				</div>
			</div>
			<button @click="start"
				class="btn btn-lg"
				:class="{ 'btn-gray': !canStart, 'btn-pink': canStart }">Start
			</button>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.btn {
		position: absolute;
		right: 121px;
		bottom: 55px;
	}
</style>

<script>
	import bus from '@/bus/event-bus.js'
	import soundManager from '@/audio/sound-manager.js'
	import audio from '@/assets/audio-test.mp3'

	export default {
		props: ['simulado'],
		data() {
			return {
				testouAudio: false,
				audio: null
			}
		},
		mounted() {
			this.audio = this.makeAudio();
		},
		computed: {
			tempoParaFazer() {
				return Math.ceil(this.simulado.SimuladoTempoTotal / 60);
			},
			canStart() {
				return this.testouAudio;
			}
		},
		methods: {
			play() {
				this.audio.play()
			},
			start() {
				if(this.canStart) {
					bus.$emit('started')
				}
			},

			makeAudio() {
				var that = this
				soundManager.destroySound('audioTeste')
				return soundManager.createSound({
					id: 'audioTeste',
					url: audio
				});
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/start/Instructions.vue